module.exports = __webpack_public_path__ + "media/images/icons/material/mobile-544aede0c4b98dbfef9f6e92c0e6c10a.svg";